<template>
	<div class="" @click="$sidebar.displaySidebar(false)">			
		<div class="row ">
            <div class="col-xl-8 mb-5 mb-xl-0">
                <div class="card shadow">
                    <div class="card-body">
 						<h4 class="mb-3 card-ttl">埋め込みコード</h4>
						<div class="loading"  v-show="loading">受信中...</div>

						<ul class="radio-container">
						<li>
						<base-radio class="mb-3" name="opt-in-option" value ="single-step" v-model="optinRadio"  :inline="true" >
						1ステップ オプトイン（HTTPS only）
						</base-radio>
						</li>                             
						<li>
						<base-radio class="mb-3" name="opt-in-option" value ="multi-step" v-model="optinRadio" :inline="true" >
						2ステップ オプトイン
						</base-radio>
						</li>
						<li>
						<base-radio class="mb-3" name="opt-in-option" value ="none" v-model="optinRadio" :inline="true" >
						オプトインなし
						</base-radio>
						</li>
						
              </ul>



<div>
  <b-card no-body>
    <b-tabs card>
      <b-tab title="Tab 1" active>
        <b-card-text>Tab contents 1</b-card-text>
      </b-tab>
      <b-tab title="Tab 2">
        <b-card-text>Tab contents 2</b-card-text>
      </b-tab>
    </b-tabs>
  </b-card>
</div>


					</div>
                </div>
            </div>

		</div>
	</div>
</template>

<script>

export default {
	components: { },
	props: ['siteData'],
	data() {
		return {
			// Our data object that holds the Laravel paginator data
			siteId:null,
			siteList:{},
			selectedSiteData:{},
			optinRadio:"multi-step"
		}
	},

	mounted() {
		// Fetch initial results
		this.siteId = window.PushL.site_id;	
		console.log(this.siteData)
		this.selectedSiteData = JSON.parse(this.siteData);
	},

	methods: {
		setStatus(response) {
      	this.siteList = response.data.sitelist;
    	},
		copyToClipboard() {
			
			let clipboardText = document.getElementById("siteTag");
            console.log(clipboardText.value);
			console.log("sssssss");
			// Select the text field
			//clipboardText.select();
			//clipboardText.setSelectionRange(0, 99999); // For mobile devices

			if(navigator.clipboard == undefined) {
				window.clipboardData.setData('text/html', clipboardText.value);
			} else {
				navigator.clipboard.writeText(clipboardText.value);
			}


			document.getElementById("custom-tooltip").style.display = "inline";
			setTimeout( function() {
				document.getElementById("custom-tooltip").style.display = "none";
			}, 1000);

		}
	}

}
</script>

<style scoped>
.selected-option {
	margin-right: 20px;
	min-width:200px;
}
.copybutton {
	background-color:transparent;
	border:0;
	outline:0;
	cursor:pointer;
	opacity:1;
	position:absolute;
	top: 10px;
	right:10px;
	z-index:9;
	border-radius:24px;
}
.button-tooltip-container {
    display: flex;
    align-items: center;
    margin-top: 16px;
    min-height: 30px;
}

#custom-tooltip {
    display: none;
    margin-left: 40px;
    padding: 5px 12px;
	background-color: rgba(94,118,228, .9);
    border-radius: 4px;
    color: #fff;
	position:absolute;
	right:10px;
	top: -40px;
}

textarea {
	width: 100%;
	height: 200px;
	resize: none;
	border:1px solid #CDD3D9;
}
.opt-val {
	display:block;
	margin-top: 10px;
}

.card {
	max-width: 1024px;
}

.card-body {
	padding: 3.6rem;
}
</style>